import React, { useEffect } from "react";
import { Switch } from "@mui/material";
import { Button } from "src/business-types/grocery/components/Button";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { PageTitle } from "../PageTitle";
import { useUser } from "src/business-types/grocery/components/UserContext";

const ReportsTab = () => {
  const { pdfProductLimit, setPdfProductLimit, showOutstanding, setShowOutstanding, saveReports } = useConfigurationState();
  const { user } = useUser();

  const handleSave = () => {
    saveReports({
      pdfProductLimit,
      showOutstanding,
    });
  };

  useEffect(() => {
    if (user?.businessType !== "Grocery") {
      document.title = "Reports› Configuration › iMetanic";
    }
  }, []);

  return (
    <div className='w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-md border border-gray-100 p-8 mt-4'>
      <PageTitle title=' - Configuration › Reports' /> {/* Header */}
      <div className='mb-8'>
        <h2 className='text-2xl font-semibold text-gray-800 tracking-tight'>Daily Report Configuration</h2>
        <p className='text-sm text-gray-500 mt-1'>Configure how your PDF reports should appear.</p>
      </div>
      {/* Settings Grid */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
        {/* Product Limit Card */}
        <div className='bg-gray-50 rounded-xl p-6 border border-gray-100 hover:shadow-sm transition'>
          <label className='block text-sm font-semibold text-gray-700 mb-3'>Maximum Products in PDF</label>

          <select
            value={pdfProductLimit}
            onChange={(e) => setPdfProductLimit(e.target.value)}
            className='w-full h-11 rounded-lg border border-gray-300 bg-white px-4 text-sm
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition'
          >
            <option value='10'>10 Products</option>
            <option value='20'>20 Products</option>
            <option value='50'>50 Products</option>
            <option value='100'>100 Products</option>
            <option value='all'>Show All</option>
          </select>

          <p className='text-xs text-gray-500 mt-3'>Choose how many products should appear in the generated PDF.</p>
        </div>

        {/* Outstanding Toggle Card */}
        <div className='bg-gray-50 rounded-xl p-6 border border-gray-100 hover:shadow-sm transition'>
          <label className='block text-sm font-semibold text-gray-700 mb-3'>Display Outstanding Balance</label>

          <div className='flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-3'>
            <span className='text-sm text-gray-600'>{showOutstanding ? "Outstanding shown" : "Outstanding hidden"}</span>
            <Switch checked={showOutstanding} onChange={(e) => setShowOutstanding(e.target.checked)} color='primary' />
          </div>

          <p className='text-xs text-gray-500 mt-3'>Enable to include outstanding balance details in the PDF.</p>
        </div>
      </div>
      {/* Save Button */}
      <div className='flex justify-center mt-8'>
        <Button label='Save Report Settings' onClick={handleSave} />
      </div>
    </div>
  );
};

export default ReportsTab;
